const obtenerErrorFirebase = (error, code) => {
  const messages = {
    "zonda/enterprise-denied": "No puedes acceder a Zonda porque tu empresa registrada en Capacitaciones no es Zonda Bus.",
    "zonda/access-denied": "Tu cuenta no tiene acceso habilitado a Zonda. Comunícate con el administrador.",
    "auth/network-request-failed": "No se pudo conectar con Firebase. Revisa tu conexión a Internet.",
    "auth/wrong-password": "El correo o la contraseña de Capacitaciones no son correctos.",
    "auth/invalid-login-credentials": "El correo o la contraseña de Capacitaciones no son correctos.",
    "auth/invalid-credential": "El correo o la contraseña de Capacitaciones no son correctos.",
    "auth/user-not-found": "No se encontró esa cuenta en Firebase.",
    "auth/user-disabled": "Esta cuenta está deshabilitada en Firebase.",
    "auth/too-many-requests": "Demasiados intentos. Espera un momento antes de intentar de nuevo."
  }
  if (messages[code]) return messages[code]
  if (code === "zonda/profile-unavailable" || code === "zonda/session-invalid") return error
  let message = ""
  switch (error) {
    case "There is no user record corresponding to this identifier. The user may have been deleted.":
      message =
        "No hay ningún registro de usuario que corresponda a estas credenciales."
      break

    case "The email address is badly formatted.":
      message = "La dirección de correo electrónico está mal formateada."
      break

    case "The password is invalid or the user does not have a password.":
      message = "La contraseña no es válida o el usuario no tiene contraseña."
      break

    case "Access to this account has been temporarily disabled due to many failed login attempts. You can immediately restore it by resetting your password or you can try again later.":
      message =
        "El acceso a esta cuenta se ha deshabilitado temporalmente. Puede intentarlo de nuevo más tarde."
      break
    case undefined:
      message =
        "Error al cargar sus datos solicite atención con el equipo de desarollo"
      break

    default:
      message = "No se pudo completar el inicio de sesión. Intenta nuevamente."
      break
  }
  return message
}

export { obtenerErrorFirebase }
